import {useState, useEffect} from "react";

export function Checkbox({
  type = 'checkbox', label, checked = false,
  className, classNameParent, onChange, ...props
}) {
  const [isChecked, setIsChecked] = useState(checked)

  useEffect(() => {
    setIsChecked(checked)
  }, [checked])

  const handleChange = e => {
    // setIsChecked((prev) => !prev)
    setIsChecked(e.target.checked)

    if (onChange)
      onChange(e.target.checked)
  }

  return (
    <div className={'custom-input ' + type + (classNameParent ? ' ' + classNameParent : '')}>
      <label>
        <input type={type} checked={isChecked}
          className={(className ? className + ' ' : '') + (isChecked ? 'checked' : '')}
          onChange={handleChange}
          {...props}
        />
        {
          label &&
          <span>{label}</span>
        }
      </label>
    </div>
  )
}
